import * as z from "zod";

export const updateInventoryViewFolder = {
  name: "updateInventoryViewFolder" as const,
  input: z.object({ folderId: z.string(), name: z.string() }),
  output: z.object({}),
};
